/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Entity,
    EntityFromJSON,
    EntityFromJSONTyped,
    EntityToJSON,
    EntityListAllOf,
    EntityListAllOfFromJSON,
    EntityListAllOfFromJSONTyped,
    EntityListAllOfToJSON,
    List,
    ListFromJSON,
    ListFromJSONTyped,
    ListToJSON,
} from './';

/**
 * 
 * @export
 * @interface EntityList
 */
export interface EntityList {
    /**
     * The total number of records that match the query, i.e. the number of records
     * the query would return with limit=infinity.
     * @type {number}
     * @memberof EntityList
     */
    total_count: number;
    /**
     * Whether total_count is clipped for performance reasons.
     * @type {boolean}
     * @memberof EntityList
     */
    is_total_count_clipped: boolean;
    /**
     * 
     * @type {Array<Entity>}
     * @memberof EntityList
     */
    entities: Array<Entity>;
}

export function EntityListFromJSON(json: any): EntityList {
    return EntityListFromJSONTyped(json, false);
}

export function EntityListFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntityList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'entities': ((json['entities'] as Array<any>).map(EntityFromJSON)),
    };
}

export function EntityListToJSON(value?: EntityList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'entities': ((value.entities as Array<any>).map(EntityToJSON)),
    };
}


